import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment'

const PolicyDetails = (props) => {
    const { policy } = props
    return (
        <div style={{ marginTop: 12, marginBottom: 12 }}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    style={{ backgroundColor: '#F1F7F0' }}
                >
                    <Typography>Policy Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography mt={2}>
                        {policy.planName}
                    </Typography>
                    <Typography mt={2}>
                        {`Policy number - ${policy.policyNumber}`}
                    </Typography>
                    <Typography mt={2}>
                        {`Premium - ₹${policy.premium}`}
                    </Typography>
                    <Typography mt={2}>
                        {`Commencement Date - ${moment(policy.commencementDate).format('DD-MM-YYYY')}`}
                    </Typography>
                    <Typography mt={2}>
                        {`Policy Term - ${policy.term} Years`}
                    </Typography>
                    <Typography mt={2}>
                        {`Payment Term - ${policy.paymentTerm} Years`}
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default PolicyDetails
